import { CrossTabMessage } from './cross-tab-message';

/**
 * サイト設定（管理画面の表示設定）が変わった。受けたタブは読み込み直す。
 * 送り手: src/components/site/context/site-provider.js
 */
export class SiteConfigChangedMessage extends CrossTabMessage {
    static topic = 'site/config_changed';

    static fromFields({ siteId }) {
        return typeof siteId === 'string' && siteId ? new SiteConfigChangedMessage({ siteId }) : null;
    }
}

CrossTabMessage.register(SiteConfigChangedMessage);
